import { Navigate, Outlet, useParams, useSearchParams } from "react-router-dom";

import { getPagePath, PAGES } from "@/config/pages";
import { isSupportedLanguage } from "@/i18n/routing";
import { useAuthStore } from "@/stores/AuthStore";
import { useOrganisationStore } from "@/stores/OrganisationStore";
import { INVITATION_TOKEN_QUERY_PARAM } from "@/Utils/Auth/invitation";

const PublicRoute = () => {
  const { lang } = useParams<{ lang: string }>();
  const { isAuthenticated } = useAuthStore();
  const { organisation } = useOrganisationStore();
  const [searchParams] = useSearchParams();

  if (isAuthenticated) {
    const invitationToken = searchParams.get(INVITATION_TOKEN_QUERY_PARAM);

    if (!organisation) {
      const onboardingPath = isSupportedLanguage(lang)
        ? getPagePath("onboarding", lang)
        : PAGES.onboarding;

      return (
        <Navigate
          to={
            invitationToken
              ? `${onboardingPath}?${INVITATION_TOKEN_QUERY_PARAM}=${encodeURIComponent(invitationToken)}`
              : onboardingPath
          }
          replace
        />
      );
    }

    const eventsPath = isSupportedLanguage(lang)
      ? getPagePath("events", lang)
      : PAGES.events;
    return <Navigate to={eventsPath} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
